type TopInfoBannerType = {
  data?: TopInfoBannerType
  headline: string
  textContent: string
  link?: string
  textLink?: string
  customCssClass?: string
  countdownDate?: {
    value: Date
  }
  couponCode?: string
  backgroundColor?: keyof typeof TopInfoBannerBackgroundColors
  displayInfoBannerByDefault?: boolean
}

export type CouponProps = {
  code: string
  cssClass: string
}

export const TopInfoBannerBackgroundColors = {
  black: { bg: 'bg-black', icon: 'fill-black' },
  green: { bg: 'bg-coffeeGreenDark', icon: 'fill-coffeeGreenDark' },
  brown: { bg: 'bg-coffeeBrown', icon: 'fill-coffeeBrown' },
  jasmin_lightGreen: { bg: 'bg-platinaGreen', icon: 'fill-platinaGreen' },
  jasmin_darkGreen: { bg: 'bg-pineGreen', icon: 'fill-pineGreen' },
  jasmin_red: { bg: 'bg-teaFruit', icon: 'fill-teaFruit' }
}

export default TopInfoBannerType
